module.exports = __webpack_public_path__ + "img/AI流行趋势配图.ff43dccb.png";